export enum InputFieldType {
  textField = 'textField',
  textArea = 'textArea',
  checkBox = 'checkBox',
  image = 'image',
  multiImage = 'multiImage',
}
